var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLine',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.calcOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }